import { render, staticRenderFns } from "./ac-sql-builder-ui.vue?vue&type=template&id=bbc4b1ac&scoped=true&"
import script from "./ac-sql-builder-ui.vue?vue&type=script&lang=js&"
export * from "./ac-sql-builder-ui.vue?vue&type=script&lang=js&"
import style0 from "./ac-sql-builder-ui.vue?vue&type=style&index=0&id=bbc4b1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4b1ac",
  null
  
)

export default component.exports